// SPDX-License-Identifier: AGPL-3.0-or-later

import {convertToCodePoints} from '@app/features/expressions/utils/EmojiCodepointUtils';
import {MODE} from '@app/features/platform/types/Env';
import type {FC, SVGProps} from 'react';

const TWEMOJI_CDN = 'https://fluxerstatic.com/emoji';
const TWEMOJI_VERSION = '2';
type TwemojiComponent = FC<SVGProps<SVGSVGElement>>;
export const shouldUseNativeEmoji = false;
export function fromHexCodePoint(hex: string): string {
	return String.fromCodePoint(Number.parseInt(hex, 16));
}
export function getTwemojiURL(codePoints: string): string | null {
	if (MODE === 'test' || !codePoints) {
		return null;
	}
	return `${TWEMOJI_CDN}/${codePoints}.svg?v=${TWEMOJI_VERSION}`;
}
export function getEmojiURL(unicode: string): string | null {
	return getTwemojiURL(convertToCodePoints(unicode));
}
export function getTwemojiSvg(_codePoints: string): TwemojiComponent | null {
	return null;
}
export function getEmojiSvg(_unicode: string): TwemojiComponent | null {
	return null;
}
